import React from 'react';

import IncidentStatusEnum from 'redpoints-model-js/enumeration/IncidentStatusEnum';

import { getLiteralKey, translate } from '../../../helpers/languageHelper';
import { DEFAULT_PAGINATION_SIZE_OPTIONS } from '../../../helpers/paginationHelper';
import { alphabeticalSort } from '../../../helpers/sortingHelpers';

const renderElement = element => {
  const emptyRender = '-';
  return (
    <p title={element} className="audit-results-table-data">
      {element ?? emptyRender}
    </p>
  );
};

const renderObjectWithLiteralKey = item => {
  const key = item && getLiteralKey(item.literalKey);
  const itemToRender = key ? translate(key) : undefined;
  return renderElement(itemToRender);
};

const renderExists = (a, record) => {
  const existsTranslation = translate(
    `common.${record.auditedIncidentId ? 'yes' : 'no'}`
  );

  return renderElement(existsTranslation);
};

export const getRowClassName = record => {
  if (record.auditIncidentId && !record.auditedIncidentId) {
    return 'table-row-missing-links';
  } else if (
    record.auditIncidentId &&
    record.auditedIncidentId &&
    (record.auditedProtectionType !== record.auditProtectionType ||
      record.auditIncidentStatus !== record.auditedIncidentStatus)
  ) {
    return record.auditedIncidentStatus?.value ===
      IncidentStatusEnum.CONFIRMATION_DISCARDED.value
      ? 'table-row-mismatch-by-customer'
      : 'table-row-mismatch';
  } else {
    return 'table-row-match';
  }
};

export const auditResultsColumns = [
  {
    dataIndex: 'auditIncidentId',
    key: 'auditIncidentId',
    sorter: (a, b) => a.auditIncidentId - b.auditIncidentId,
    title: translate('auditResults.table.columns.incidentId'),
    width: '8%',
  },
  {
    dataIndex: 'detectionLinkUrl',
    ellipsis: true,
    key: 'detectionLinkUrl',
    render: renderElement,
    title: translate('auditResults.table.columns.detectionLinkUrl'),
    width: '14%',
  },
  {
    dataIndex: 'contentLinkUrl',
    key: 'contentLinkUrl',
    render: renderElement,
    title: translate('auditResults.table.columns.contentLinkUrl'),
    width: '14%',
  },
  {
    dataIndex: 'auditIncidentStatus',
    key: 'auditIncidentStatus',
    render: renderObjectWithLiteralKey,
    sorter: (a, b) =>
      alphabeticalSort(
        a.auditIncidentStatus?.name,
        b.auditIncidentStatus?.name
      ),
    title: translate('auditResults.table.columns.incidentStatus'),
    width: '12%',
  },
  {
    dataIndex: 'auditProtectionType',
    key: 'auditProtectionType',
    render: renderObjectWithLiteralKey,
    sorter: (a, b) =>
      alphabeticalSort(
        a.auditProtectionType?.name,
        b.auditProtectionType?.name
      ),
    title: translate('auditResults.table.columns.protectionType'),
    width: '12%',
  },
  {
    dataIndex: 'existsInTheAuditedAsset',
    key: 'existsInTheAuditedAsset',
    render: renderExists,
    sorter: (a, b) => a.auditedIncidentId - b.auditedIncidentId,
    title: translate('auditResults.table.columns.existsInTheAuditedAsset'),
    width: '8%',
  },
  {
    dataIndex: 'auditedIncidentId',
    key: 'auditedIncidentId',
    render: renderElement,
    sorter: (a, b) => a.auditedIncidentId - b.auditedIncidentId,
    title: translate('auditResults.table.columns.incidentId'),
    width: '8%',
  },
  {
    dataIndex: 'auditedIncidentStatus',
    key: 'auditedIncidentStatus',
    render: renderObjectWithLiteralKey,
    sorter: (a, b) =>
      alphabeticalSort(
        a.auditedIncidentStatus?.name,
        b.auditedIncidentStatus?.name
      ),
    title: translate('auditResults.table.columns.incidentStatus'),
    width: '12%',
  },
  {
    dataIndex: 'auditedProtectionType',
    key: 'auditedProtectionType',
    render: renderObjectWithLiteralKey,
    sorter: (a, b) =>
      alphabeticalSort(
        a.auditedProtectionType?.name,
        b.auditedProtectionType?.name
      ),
    title: translate('auditResults.table.columns.protectionType'),
    width: '12%',
  },
];

export const auditResultsPagination = ({ number, size, totalPages } = {}) => ({
  current: number + 1,
  pageSize: size,
  pageSizeOptions: DEFAULT_PAGINATION_SIZE_OPTIONS,
  total: totalPages,
});
